import gql from "graphql-tag";

const getGastronomies = gql`
  query getGastronomies($params: GastronomySearchParams!) {
    getGastronomies(params: $params) {
      uuid
      name
      type
      street
      zip
      city
      lat
      lng
      logo_image
      website
      header_image
      portrait_image
      created_at
      isActive
      isOpen
      distance_in_km
      options {
        coming_soon
        hasTakeAway
        hasTableOrder
        hasSelfService
        hasDelivery
        hasReservation
        hasDriveIn
      }
    }
  }
`;

export { getGastronomies };
